import { ProcessTypeConfigModel } from "../models/processTypeConfigModel";

export function updateSimpleProcessFields(config: ProcessTypeConfigModel) {
    let simpleBuildingDetails = $("#simple-building");
    let classicBuildingDetails = $("#classic-building");
    let constructionForOwnUseSection = $("#construction-for-own-use-section");

    if (config.IsSimpleProcess) {
        simpleBuildingDetails.show();
        classicBuildingDetails.hide();
        constructionForOwnUseSection.show();
    }
    else {
        simpleBuildingDetails.hide();
        classicBuildingDetails.show();
        constructionForOwnUseSection.hide();
    }
}
